import React, { useState, useEffect } from 'react';
import { Form, FormGroup, FormText, Button } from 'reactstrap';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import TextFieldGroup from '../../Common/TextFieldGroup';
import CheckboxFieldGroup from '../../Common/CheckboxFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import { Page } from '../../../Data/Classes';

function PageEditForm(props) {
    const [isProgress, setIsProgress] = useState(false);
    const [error, setError] = useState({});
    const [page, setPage] = useState(null);

    let editorC = null;

    useEffect(() => {
        setPage(props.page);
    }, [props.page]);

    function onChange(e) {
        setPage({ ...page, [e.target.name]: e.target.value });
    }

    function onCheckedChange(e) {
        setPage({ ...page, [e.target.name]: e.target.checked });
    }

    function onDeleteClick(e) {
        if (window.confirm("Biztos, hogy törlöd a lapot?\nA művelet nem visszavonható.")) {
            setIsProgress(true);
            Axios.delete(`/admin/pages/${page.id}`)
                .then(res => {
                    setIsProgress(false);
                    toast.success("Lap törölve.");
                    window.history.back();
                }, err => {
                    setIsProgress(false);
                    toast.error("A lap törlése sikertelen volt.");
                });
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        setIsProgress(true);
        Axios.post(`/admin/pages/${page.id}`,
            new Page(page.id,
                page.title,
                page.titleInUrl,
                page.priority,
                page.content,
                page.public))
            .then(res => {
                setIsProgress(false);
                toast.success(`${page.title} elmentve.`);
                window.history.back();
            }, err => {
                setIsProgress(false);
                setError(err.errors);
                toast.error("A lap mentése sikertelen volt.");
            });
    }

    if (isProgress)
        return <ProgressIndicator />;

    if (page)
        return (
            <Form onSubmit={onSubmit} id="pageEditForm">
                <FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="title"
                            onChange={onChange}
                            label="Cím"
                            error={error.Title}
                            value={page.title} />
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="titleInUrl"
                            onChange={onChange}
                            label="Cím az URL-ben"
                            error={error.TitleInUrl}
                            value={page.titleInUrl} />
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="priority"
                            type="number"
                            onChange={onChange}
                            label="Prioritás"
                            error={error.Priority}
                            value={page.priority} />
                    </FormGroup>
                    <FormGroup>
                        <label>Tartalom</label>
                        <CKEditor
                            editor={DecoupledEditor}
                            data={page.content}
                            onReady={editor => {
                                editor.ui.getEditableElement().parentElement.insertBefore(
                                    editor.ui.view.toolbar.element,
                                    editor.ui.getEditableElement()
                                );

                                editorC = editor;
                            }}
                            onError={(error, { willEditorRestart }) => {
                                if (willEditorRestart) {
                                    editorC.ui.view.toolbar.element.remove();
                                }
                            }}
                            onChange={(ev, editor) => {
                                setPage({ ...page, content: editor.getData() });
                            }}
                        />
                        {error.Content && <FormText>{error.Content}</FormText>}
                    </FormGroup>
                    <CheckboxFieldGroup
                        field="public"
                        onChange={onCheckedChange}
                        label="Nyilvános"
                        error={error.Public}
                        value={page.public}
                    />
                </FormGroup>
                {error[""]}
                <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
                {!!page.id && <Button color="warning" type="button" onClick={onDeleteClick} className="float-right"><FontAwesomeIcon icon={faTrash} /> Törlés</Button>}
            </Form>
        );

    return null;
}

export default PageEditForm;
